import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { getControlEntityAttributes } from '../../utils/control-helper';
import { QueryConditionSettingModel } from '../../types/query-condition-setting-model';

@Component({
  selector: 'df-query-condition-editor',
  templateUrl: './query-condition-editor.component.html',
  styleUrls: ['./query-condition-editor.component.css']
})
export class QueryConditionEditorComponent extends AbstractPropertyEditorBase implements OnInit, OnDestroy {
  // æ¯å¦ä½ä¸ºæ¥è¯¢æ¡ä»¶
  get checked(): boolean {
    return this._checked;
  }
  set checked(value: boolean) {
    this._checked = value;
    this.afterSetControlValue(null);
  }

  get valueChecked(): string {
    return this._valueChecked;
  }
  set valueChecked(value: string) {
    this._valueChecked = value;
    this.afterSetControlValue(null);
  }

  get serialNo(): number {
    return this._serialNo;
  }
  set serialNo(value: number) {
    this._serialNo = value;
    this.afterSetControlValue(null);
  }

  get rule(): string {
    return this._rule;
  }
  set rule(value: string) {
    this._rule = value;
    this.afterSetControlValue(null);
  }

  @Input() set settings(settings: any) {
    this._settings = settings;
    this.bindEntityAttributeChange();
  }
  get settings() {
    return this._settings;
  }

  private _settings: any;

  rulesSetting: any = {};
  entityAttributesSetting: {
    items: { caption: string; name: string }[];
    displayMember: string;
    valueMember: string;
  } = { items: [], displayMember: 'caption', valueMember: 'name' };

  private _checked: boolean;
  private _valueChecked: string;
  private _serialNo: number;
  private _rule: string;
  private _controlEntityAttributeSubscription: Subscription;

  constructor() {
    super();
  }

  ngOnInit() {
    this.initRuleSettings();
  }

  ngOnDestroy(): void {
    if (this._controlEntityAttributeSubscription) {
      this._controlEntityAttributeSubscription.unsubscribe();
    }
  }

  initRuleSettings() {
    if (!this.settings.rules) {
      return;
    }
    const rules: Array<any> = [];
    for (const s of Object.keys(this.settings.rules)) {
      rules.push({ text: this.settings.rules[s], name: s });
    }
    this.rulesSetting.items = rules;
    this.rulesSetting.displayMember = 'text';
    this.rulesSetting.valueMember = 'name';
  }

  afterControlValueInit() {
    if (!this.value) {
      this.value = {};
    }
    this.checked = this.value['checked'];
    this.serialNo = this.value['serialNo'] ? this.value['serialNo'] : 1;
    this.rule = this.value['rule'] ? this.value['rule'] : 'eq';
  }

  afterSetControlValue(value: any) {
    if (this.checked) {
      this.valueChange.emit({
        checked: this.checked,
        serialNo: this.serialNo,
        rule: this.rule,
        valueChecked: this.valueChecked
      });
    } else {
      this.valueChange.emit({ checked: this.checked });
    }
  }

  private bindEntityAttributeChange() {
    if (this.settings['entityAttributeChange$']) {
      this._controlEntityAttributeSubscription = (this
        .settings as QueryConditionSettingModel).entityAttributeChange$.subscribe((s) => {
        this.entityAttributesSetting = {
          items: getControlEntityAttributes(s.entityAttributes, this.control.model),
          displayMember: 'caption',
          valueMember: 'name'
        };
      });
    }
  }
}
